const initialState = { lookupTypes: {} };

const lookupData = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case "LOOKUP_DATA_RECEIVED": {
			const { values, lookupType } = payload;
			return {
				...state,
				[lookupType]: values
			};
		}
		case "LOOKUPTYPES_RECEIVED": {
			const { lookupData } = payload;
			const normalizedLookupTypes = lookupData.reduce((acc, item) => {
				acc[item.lookupType] = item;
				return acc;
			}, {});
			return {
				...state,
				lookupTypes: normalizedLookupTypes
			};
		}
		default:
			return state;
	}
};

export default lookupData;
